export default __webpack_public_path__ + "static/media/review-icon.0b8c0f4a.svg";